import axios from "axios";
import { baseUrl, portal } from "../App";

export const fetchTodyLeaderboard = async (eventId) => {
  if(!eventId) return [];
  const res = await axios.get(`${baseUrl}/api/leaderboard/?portal=${portal}&event_id=${eventId}`);
  return res.data;
}